module.exports = __webpack_public_path__ + "static/media/svetna-icon.ce8e5869.png";